import {Link} from "react-router-dom";

export const ServiceIcon = ({service}) => {
    return (
        <Link to={`/converter/service/${service.id}`} className="service-button">
            <img src={service.logo} alt={service.name} className="img-fluid rounded-5"/>
            <p className="text-center text-white mt-2 mb-0">{service.name}</p>
        </Link>
    )
}